import styled from "styled-components";
import { SP_BREAKPOINT } from "../../constants/app";

type Props = {
  title: string;
  children: React.ReactNode;
};

export const CardTemplate: React.FC<Props> = ({ title, children }) => {
  return (
    <StyledContentContainer>
      <StyledTitle>{title}</StyledTitle>

      {children}
    </StyledContentContainer>
  );
};

const StyledContentContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    width: 100%;
    padding: 32px 24px 40px 24px;
  }

  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 500px;
  background-color: #ffffff;
  padding: 40px 56px 48px 56px;
  border-radius: 5px;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.2);
`;

const StyledTitle = styled.h1`
  font-size: 32px;
  line-height: 48px;
  font-weight: 400;
  text-align: center;

  @media (max-width: ${SP_BREAKPOINT}) {
    font-size: 24px;
    line-height: 150%;
  }
`;
